import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { QUEUE_STORAGE_KEY } from './uploader.consts';
import { StoredUpload, Upload, UploadStatus } from './uploader.types';

const fileToDataUrl = (file: File): Promise<string | ArrayBuffer | null> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

const dataURLtoFile = (dataurl: string, filename: string) => {
  const arr = dataurl.split(',');
  const mime = arr?.[0]?.match(/:(.*?);/)?.[1] ?? 'image/jpeg';
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
};

const getQueueFromStorage = (): Upload[] => {
  const queue = localStorage.getItem(QUEUE_STORAGE_KEY);
  if (!queue) return [];
  return (JSON.parse(queue) as StoredUpload[]).map(
    ({ _id, processedChunks, error, destination, filename, file, status }) => ({
      _id,
      file: dataURLtoFile(file, filename), //  new File([_id], filename),
      processedChunks,
      error,
      destination,
      status,
    })
  );
};

const writeQueueToStorage = async (queue: Upload[]) => {
  // const x = await Promise.all(
  //   queue.map(async (i) => {
  //     return {
  //       _id: i._id,
  //       file: await fileToDataUrl(i.file),
  //       filename: i.file.name,
  //       processedChunks: i.processedChunks,
  //       error: i.error,
  //       destination: i.destination,
  //       status: i.status,
  //     };
  //   })
  // );
  // try {
  //   localStorage.setItem(QUEUE_STORAGE_KEY, JSON.stringify(x));
  // } catch (e) {
  //   console.error(e);
  // }
};

export interface UploaderState {
  uploads: Upload[];
}

const initialState: UploaderState = {
  uploads: [], //getQueueFromStorage(),
};

// export const updateUploadAsync = createAsyncThunk(
//   'uploader/updateUpload',
//   async (payload: Partial<Upload>, { getState }) => {
//     const state = getState() as RootState;
//     const current = state.uploader.uploads.find((i) => i._id === payload._id);
//     const newState = [
//       { ...current, ...payload },
//       ...state.uploader.uploads.filter((i: Upload) => i._id !== payload._id),
//     ];
//     //await writeQueueToStorage(newState as Upload[]);
//     return newState;
//   }
// );

// export const addUploadsAsync = createAsyncThunk(
//   'uploader/addUploads',
//   async (payload: Pick<Upload, 'file' | 'destination'>[], { getState }) => {
//     const state = getState() as RootState;
//     const newState = [
//       ...state.uploader.uploads,
//       ...payload.map((upload) => ({
//         _id: Math.random().toString(36).substr(2, 9),
//         ...upload,
//         processedChunks: 0,
//         status: UploadStatus.Pending,
//       })),
//     ];
//     //await writeQueueToStorage(newState);
//     return newState;
//   }
// );

// export const cancelUploadsAsync = createAsyncThunk(
//   'uploader/cancelUpload',
//   async (payload: string, { getState }) => {
//     const state = getState() as RootState;
//     const newState = state.uploader.uploads.filter((i) => i._id !== payload);
//     //await writeQueueToStorage(newState);
//     return newState;
//   }
// );

export const uploaderSlice = createSlice({
  name: 'uploader',
  initialState,
  reducers: {
    clearUploads: (state) => {
      state.uploads = [];
    },
    addUploads: (
      state,
      action: PayloadAction<
        Pick<Upload, 'file' | 'destination' | 'onComplete'>[]
      >
    ) => {
      state.uploads = [
        ...state.uploads,
        ...action.payload.map((upload) => ({
          _id: Math.random().toString(36).substr(2, 9),
          ...upload,
          processedChunks: 0,
          status: UploadStatus.Pending,
        })),
      ];
    },
    cancelUpload: (state, action: PayloadAction<string>) => {
      //TODO: cancel actual upload
      state.uploads = state.uploads.filter(
        (upload) => upload._id !== action.payload
      );
    },
    upadteUpload: (state, action: PayloadAction<Partial<Upload>>) => {
      const current = state.uploads.find((i) => i._id === action.payload._id);
      state.uploads = [
        { ...current, ...action.payload } as Upload,
        ...state.uploads.filter((i: Upload) => i._id !== action.payload._id),
      ];
    },
  },
  extraReducers: (builder) => {
    // builder.addCase(addUploadsAsync.fulfilled, (state, action) => {
    //   state.uploads = action.payload;
    // });
    // builder.addCase(cancelUploadsAsync.fulfilled, (state, action) => {
    //   state.uploads = action.payload;
    // });
    // builder.addCase(updateUploadAsync.fulfilled, (state, action) => {
    //   state.uploads = action.payload as Upload[];
    // });
  },
});

export const selectUploads = (state: RootState) => state.uploader.uploads;

export const { cancelUpload, addUploads, upadteUpload } = uploaderSlice.actions;

export default uploaderSlice.reducer;
